import React, { useEffect, useRef, useState } from "react"
import { useApiService } from "../hooks/Api/useApiService"
import { useLocation } from "react-router-dom"
import styles from "./ProfileCard.module.css"
import { useUser } from "../hooks/Contexts/UserContext/UserContext"
import useDeviceType from "../hooks/Utils/useDeviceType"
import Feed from "../Feed/Feed"
import Spinner from "../UI/Spinner/Spinner"
import SimilarUsers from "./SimilarUsers"
import ProfileCard from "./ProfileCard"
import T from "../hooks/Language/T"
import LinkNetwork from "../LinkNetwork/LinkNetwork"
import { Button } from "@mui/material"
import AddTestamonyModal from "../Modals/AddTestamonyModal/AddTestamonyModal"
import useTranslationSharie from "../hooks/Language/useTranslation"
import BusinessCard from "./BusinessCard"
import Post from "../Post/Post"
import SurveyModal from "../Modals/SurveyModal/SurveyModal"
import HobbiesSection from "./HobbiesSection"
import TransferCredit from "./TransferCredit"

const ProfilePage = React.memo(() => {
  const [edit_able, setEditable] = useState(null)
  const { postData } = useApiService()
  const location = useLocation()
  const { context_user, updateUser } = useUser()
  const deviceType = useDeviceType()
  const user_name = location.state?.user_name || localStorage.getItem("user") // ||localStorage.getItem("currentuser")
  const [scrollPercentage, setScrollPercentage] = useState(0)
  const add_testamonyRef = useRef()
  const t = useTranslationSharie()
  const surveyRef = useRef()

  useEffect(() => {
    // if (user_name !== localStorage.getItem("currentuser"))
    //   localStorage.setItem("currentuser", user_name)
    setEditable(location.state?.editable)
    postData("users/getuser", { user_name: user_name || localStorage.getItem("user") })
      .then((data) => {
        if (data?.user?.length > 0) {
          updateUser(data?.user[0])
        }
      })
      .catch((error) => {})
  }, [user_name, location.state?.editable])
  const openTestimonyModal = () => add_testamonyRef.current?.childFunction()
  const openSurveyModal = () => surveyRef.current?.childFunction()

  return (
    <T>
      <SurveyModal ref={surveyRef} setAnchorEl={() => {}} setIsAuthenticated={() => {}} />
      <AddTestamonyModal ref={add_testamonyRef} />

      <div
        className={
          deviceType === "desktop"
            ? styles.profile_page_container_desktop
            : styles.profile_page_container_mobile
        }
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          {localStorage.getItem("user") === user_name && <TransferCredit />}
          <ProfileCard user_name={user_name} edit_able={edit_able} />
          <div style={{ padding: 20 }}>
            <BusinessCard user_name={user_name} />
          </div>

          {localStorage.getItem("user") === user_name && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "space-between",
                width: "100%",
              }}
            >
              <Button
                style={{ margin: "1.7rem" }}
                variant='contained'
                color='secondary'
                onClick={openTestimonyModal}
                disabled={localStorage.getItem("guest") === "true"}
              >
                {t("Add Testamony")}
              </Button>
              <Button
                style={{ margin: "1.7rem" }}
                variant='outlined'
                color='secondary'
                onClick={openSurveyModal}
                disabled={localStorage.getItem("guest") === "true"}
              >
                {t("Take A Suvrey")}
              </Button>
            </div>
          )}
          <HobbiesSection user_name={user_name} />
        </div>

        <React.Suspense fallback={<Spinner />}>
          <div style={{ width: deviceType === "desktop" ? "50%" : "100%" }}>
            <Post />
            <Feed
              scrollPercentage={scrollPercentage}
              user_name={user_name || context_user?.user_name}
              image={context_user?.image}
            />
          </div>
        </React.Suspense>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <React.Suspense fallback={<Spinner />}>
            <LinkNetwork user_name={user_name} image={context_user?.image} />
          </React.Suspense>
          <React.Suspense fallback={<Spinner />}>
            <SimilarUsers user_name={user_name} />
          </React.Suspense>
        </div>
      </div>
    </T>
  )
})

export default ProfilePage
